import { Badge, Box, type BoxProps } from '@chakra-ui/react';

import { CALLOUT_BADGE_PROPS } from './calloutBadgeStyles';

type CalloutBadgeProps = {
  children: string;
  /** Sets wrapper em height so the badge box matches adjacent label cap height. */
  textSize: BoxProps['fontSize'];
};

export function CalloutBadge({ children, textSize }: CalloutBadgeProps) {
  return (
    <Box as='span' fontSize={textSize} lineHeight='1' display='inline-flex'>
      <Badge {...CALLOUT_BADGE_PROPS}>{children}</Badge>
    </Box>
  );
}
